// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;
    background-color: rgb(15, 15, 15);
  }`, "",{"version":3,"sources":["webpack://./src/assets/spinner/spinner.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;EACnC","sourcesContent":["#loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: inherit;\n    background-color: rgb(15, 15, 15);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
